define(function (require, exports) {
    'use strict';

    /*
     * Usage: Wherever you need an editable field, insert <ice pref="nameOfPrefToUse"></ice>.
     *
     * The pref attribute controls which widget preference will be used to load and save to.
     */

    exports.ice = function () {
        return {
            restrict: 'E',
            scope: {
            },
            controller: /* @ngInject */function($scope, $attrs, $element, lpWidget) {
                $scope.designMode = window.bd && window.bd.designMode || false;
                $scope.text = lpWidget.getPreference($attrs.pref);

                $scope.save = function() {
                    lpWidget.setPreference($attrs.pref, $element.text());
                    lpWidget.model.save();
                };
            },
            template: '<span contenteditable="{{designMode}}" ng-keyup="save()">{{text}}</span>'
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/ice.js